export const CHANGE_PREMIUM_STATUS_REQUEST = "CHANGE_PREMIUM_STATUS_REQUEST";
export const CHANGE_PREMIUM_STATUS_SUCCESS = "CHANGE_PREMIUM_STATUS_SUCCESS";
export const CHANGE_PREMIUM_STATUS_FAIL = "CHANGE_PREMIUM_STATUS_FAIL";
export const CHANGE_PREMIUM_STATUS_RESET = "CHANGE_PREMIUM_STATUS_RESET";
